import React, { useState, useRef } from 'react';
import {
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Flex,
    Text,
    Button,
    Icon,
} from '@chakra-ui/react';
import { HiUpload } from 'react-icons/hi';
import { IoCloseCircleOutline } from 'react-icons/io5';

const CSingleFileUpload = ({
    label,
    fileType = 'file',
    onChange,
    required = false,
    maxFileSize = 20,
}) => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');

    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (!selectedFile) {
            setError(required ? `${label} is required.` : '');
            setFile(null);
            return;
        }

        if (fileType === 'image' && !selectedFile.type.startsWith('image/')) {
            setError('Please upload a valid image file.');
            setFile(null);
            return;
        }

        if (fileType === 'pdf' && selectedFile.type !== 'application/pdf') {
            setError('Please upload a valid PDF file.');
            setFile(null);
            return;
        }

        if (selectedFile.size > maxFileSize * 1024 * 1024) {
            setError(`File size should not exceed ${maxFileSize} MB.`);
            setFile(null);
            return;
        }

        setError('');
        setFile(selectedFile);
        if (onChange) onChange(selectedFile);
    };

    const clearFile = () => {
        setFile(null);
        setError('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        if (onChange) onChange(null);
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <FormControl isInvalid={!!error}>
            <FormLabel fontWeight="bold" fontSize="md" mb="2">
                {label}
            </FormLabel>
            {file ? (
                <Flex align="center" gap="4" w="100%">
                    <Button variant="outline" size="sm" w="30%" title={file.name}>
                        <Text id="pdf_name">{file.name}</Text>
                    </Button>
                    <Icon
                        as={IoCloseCircleOutline}
                        h={7}
                        w={7}
                        onClick={clearFile}
                        cursor="pointer"
                        title='Remove File'
                        color='red'
                    />
                </Flex>

            ) : (
                <Button
                    variant="outline"
                    leftIcon={<HiUpload />}
                    size="sm"
                    w="30%"
                    onClick={handleButtonClick}
                >
                    Upload file
                </Button>
            )}
            <FormErrorMessage>{error}</FormErrorMessage>

            <Input
                ref={fileInputRef}
                type="file"
                hidden
                onChange={handleFileChange}
                accept={fileType === 'image' ? 'image/*' : fileType === 'pdf' ? '.pdf' : undefined}
                variant="unstyled"
            />
        </FormControl>
    );
};

export default CSingleFileUpload;
